import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./SearchBar.module.scss";

interface IProps {
  placeholder: string;
  onSearch?: (value: string) => void;
  onChange?: (value: string) => void;
  shouldShowSearchIcon?: boolean;
  defaultValue?: string;
}

const SearchBar = (props: IProps) => {
  const { onSearch, shouldShowSearchIcon = true, defaultValue } = props;
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(defaultValue || "");
  }, [defaultValue]);

  return (
    <Row>
      <Col>
        <div className={styles.searchContainer}>
          <div
            style={{
              border: "1px solid #e5f0fe",
              borderRadius: "10px",
              flexDirection: "row",
              display: "flex",
              height: "40px",
              width: "100%",
            }}
          >
            <FontAwesomeIcon
              icon={faSearch}
              style={{ color: "#1E4894", padding: "10px" }}
            />
            <div className={styles.inputContainer}>
              <input
                type="text"
                placeholder={props.placeholder}
                onChange={(e: any) => {
                  const val = e.target.value;
                  props.onChange && props.onChange(val);
                  setValue(val);
                }}
                onKeyDown={(e) => {
                  if (e.code === "Enter" && onSearch) {
                    onSearch(value);
                  }
                }}
                style={{ textAlign: shouldShowSearchIcon ? "center" : "start" }}
                value={value}
              />
            </div>
          </div>
          {shouldShowSearchIcon && (
            <div
              className={["text-center", styles.iconContainer].join(" ")}
              onClick={() => onSearch && onSearch(value)}
            >
              <p
                style={{
                  cursor: "pointer",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: "600",
                  padding: "10px",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                Search
              </p>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default SearchBar;
